exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kee-breadcrumb .el-breadcrumb {\n  font-size: 0.083333rem !important;\n}", ""]);

// exports
